import { render } from "./WheelOfDestiny.vue?vue&type=template&id=8c0679e0&scoped=true&lang=pug"
import script from "./WheelOfDestiny.vue?vue&type=script&lang=ts"
export * from "./WheelOfDestiny.vue?vue&type=script&lang=ts"

import "./WheelOfDestiny.vue?vue&type=style&index=0&id=8c0679e0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-8c0679e0"

export default script